// Link component is a but e.preventdefault and with props

type LinkProps = {
	href: string;
	className?: string;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	[key: string]: any;
}

export const DummyLink: React.FC<LinkProps> = ({
	href = '#',
	children,
	className = '',
	onClick = () => null,
	...props
}) => {
	const onClickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		onClick(e);
	}

	return (
		<a
			href={href}
			className={className || ''}
			onClick={onClickHandler}
			{...props}
		>
			{children}
		</a>
	);
}